module.exports = __webpack_public_path__ + "static/media/reset.3f2c9f83.png";